import { InjectionToken } from '@angular/core';
import { AppConfig } from '@tango/app/interfaces';

export interface BankAppConfig extends AppConfig {
  featureToggles: {
    hasVirtualCardOrder: boolean;
    hasVirtualReissue: boolean;
  };
}
export const BANK_APP_CONFIG = new InjectionToken<BankAppConfig>('app.config');
